import axios from 'axios'
const axiosClient = axios.create({
	baseURL: 'https://doanluatsulamdong.org.vn:8800/api',
}
)
export default axiosClient;